import { FC } from "react";

import { CHEVRON_LEFT_ICON_PATHS } from "../utils/icon-paths";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ChevronLeftIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    {CHEVRON_LEFT_ICON_PATHS.map((d, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <path d={d} fill="currentColor" key={i} />
    ))}
  </svg>
);
